const requiredFields = [
  'slug',
  'title',
  'i18nKey',
  'images',
  'descriptionTags',
  'featureTags',
  'scenarios',
  'specTabs'
]

export const assertProductConfig = (product, productKey) => {
  if (!product) {
    throw new Error(`Missing product config: ${productKey}`)
  }

  requiredFields.forEach((field) => {
    if (!product[field]) {
      throw new Error(`Missing required product field "${field}" in ${productKey}`)
    }
  })

  ;['hero', 'description', 'feature'].forEach((field) => {
    if (!product.images[field]) {
      throw new Error(`Missing required product image "${field}" in ${productKey}`)
    }
  })

  ;['descriptionTags', 'featureTags', 'scenarios', 'specTabs'].forEach((field) => {
    if (!Array.isArray(product[field])) {
      throw new Error(`Product field "${field}" must be an array in ${productKey}`)
    }
  })
}
